// extracted by mini-css-extract-plugin
module.exports = {"supportSearch":"search_supportSearch___VJLc"};